import { type QueryFunction, useQuery } from '@tanstack/vue-query'

export const getCrudIndexQuery = <TQueryFnData>(page: Ref<number>, limit: Ref<number>, queryKey: string, queryFn: QueryFunction<TQueryFnData>, otherRefs?: Array<Ref<any | undefined> | undefined | any>, enabled?: Ref<boolean>) => {
  const queryKeyArray: Array<Ref | string | Array<Ref<any | undefined> | undefined>> = [queryKey, page, limit]

  if (otherRefs !== undefined && otherRefs.length > 0) {
    queryKeyArray.push(otherRefs)
  }

  return useQuery({
    queryKey: queryKeyArray,
    enabled,
    keepPreviousData: true,
    queryFn
  })
}
